/* RESPONSIBLE TEAM: team-inbox */
import { type RenderableData } from 'embercom/objects/inbox/renderable-data';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import { EntityType } from 'embercom/models/data/entity-types';
import AdminSummary, { type AdminSummaryWireFormat } from 'embercom/objects/inbox/admin-summary';

export interface TicketTypeChangedByAdminWireFormat {
  renderable_type: string;
  admin_summary: AdminSummaryWireFormat;
  previous_ticket_type_id: number;
  previous_ticket_type_name: string;
  previous_ticket_type_emoji?: string;
  new_ticket_type_id: number;
  new_ticket_type_name: string;
  new_ticket_type_emoji?: string;
  category: string;
}

export default class TicketTypeChangedByAdmin implements RenderableData {
  renderableType: RenderableType = RenderableType.TicketTypeChangedByAdmin;
  readonly adminSummary: AdminSummary;
  readonly previousTicketTypeId: number;
  readonly previousTicketTypeName: string;
  readonly previousTicketTypeEmoji?: string;
  readonly newTicketTypeId: number;
  readonly newTicketTypeName: string;
  readonly newTicketTypeEmoji?: string;
  readonly category: string;

  get creatingEntity() {
    return {
      type: EntityType.Admin,
      id: this.adminSummary.id,
      object: this.adminSummary,
    };
  }

  constructor(
    adminSummary: AdminSummary,
    previousTicketTypeId: number,
    previousTicketTypeName: string,
    previousTicketTypeEmoji: string | undefined,
    newTicketTypeId: number,
    newTicketTypeName: string,
    newTicketTypeEmoji: string | undefined,
    category: string,
  ) {
    this.adminSummary = adminSummary;
    this.previousTicketTypeId = previousTicketTypeId;
    this.previousTicketTypeName = previousTicketTypeName;
    this.previousTicketTypeEmoji = previousTicketTypeEmoji;
    this.newTicketTypeId = newTicketTypeId;
    this.newTicketTypeName = newTicketTypeName;
    this.newTicketTypeEmoji = newTicketTypeEmoji;
    this.category = category;
  }

  get styles() {
    return {
      backgroundColor: 'bg-beta-container',
      textColor: 'text-default',
      backgroundColorHover: 'bg-beta-container-emphasis',
    };
  }

  static deserialize(json: TicketTypeChangedByAdminWireFormat): TicketTypeChangedByAdmin {
    let adminSummary = AdminSummary.deserialize(json.admin_summary);
    return new TicketTypeChangedByAdmin(
      adminSummary,
      json.previous_ticket_type_id,
      json.previous_ticket_type_name,
      json.previous_ticket_type_emoji,
      json.new_ticket_type_id,
      json.new_ticket_type_name,
      json.new_ticket_type_emoji,
      json.category,
    );
  }
}
